<template>
  <v-card class="py-4 px-2">
    <v-card-title class="text-h5">
      <div style="display: flex; align-content: center">
        {{ $t("import.title") }}
        <!-- EXPORT TEMPLATE -->
        <vue-excel-xlsx
          :data="substancesEx"
          :columns="columns"
          :file-name="$t('import.templateName')"
          :file-type="'xlsx'"
          :sheet-name="'Substances'"
        >
          <v-btn class="ml-2" small color="primary" text>
            template excel
          </v-btn>
        </vue-excel-xlsx>
      </div>
    </v-card-title>
    <v-card-text class="py-1">
      {{ $t("import.warning") }} <br />
      {{ $t("import.warningReminder") }}
    </v-card-text>
    <v-img
      height="250"
      contain
      src="../../public/exemple_format_excel_v2.png"
    ></v-img>
    <v-container>
      <v-row justify="space-around">
        <v-col cols="10">
          <v-file-input
            accept=".xlsx"
            @change="onFileChange"
            outlined
            :label="`${$t('import.importFile')}`"
            class="mx-4 my-2"
            hide-details
          ></v-file-input>
        </v-col>
      </v-row>
      <!-- Zone analyse Excel -->
      <p v-if="erreurExcel" class="text-center text-body-2">
        {{ erreurExcel }}
      </p>
      <v-expand-transition>
        <div v-if="!displayAnalyseBack">
          <div class="text-center text-body-2" v-if="substancesToSearch">
            {{ $t("import.success") }} - {{ substancesToSearch }}
            {{ $t("import.subToSearch") }}
          </div>
          <div
            class="text-center text-body-2"
            v-if="substancesImportExcelError.format.length"
          >
            {{ substancesImportExcelError.format.length }}
            {{ $t("import.Error.format") }}
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <a v-bind="attrs" v-on="on">
                  ({{ $t("import.Error.list") }})
                </a>
              </template>
              <span>{{ substancesImportExcelError.format }}</span>
            </v-tooltip>
          </div>
          <div
            class="text-center text-body-2"
            v-if="substancesImportExcelError.empty.length"
          >
            {{ substancesImportExcelError.empty.length }}
            {{ $t("import.Error.empty") }}
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <a v-bind="attrs" v-on="on">
                  ({{ $t("import.Error.list") }})
                </a>
              </template>
              <span>{{ substancesImportExcelError.empty }}</span>
            </v-tooltip>
          </div>
          <div
            class="text-center text-body-2"
            v-if="substancesImportExcelError.double.length"
          >
            {{ substancesImportExcelError.double.length }}
            {{ $t("import.Error.double") }}
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <a v-bind="attrs" v-on="on">
                  ({{ $t("import.Error.list") }})
                </a>
              </template>
              <span>{{ substancesImportExcelError.double }}</span>
            </v-tooltip>
          </div>
        </div>
      </v-expand-transition>
    </v-container>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="closeImport">
        {{ $t("generic.cancel") }}
      </v-btn>
      <v-btn color="primary" @click="send" :disabled="!isSubToSearch">
        {{ $t("import.launchSearch") }}
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>

    <!-- Zone d'analyse et de résultats -->
    <v-expand-transition>
      <v-card v-if="displayAnalyseBack" class="mt-4 py-4 px-2">
        <v-divider></v-divider>
        <v-card-title class="text-h5">
          {{ $t("generic.resultOfSearch") }}
        </v-card-title>
        <div v-if="loaderBackEnd">
          <v-card-text class="py-1">
            <v-progress-circular
              indeterminate
              color="primary"
              class="mr-4"
            ></v-progress-circular>
            {{ $t("import.resultLoader") }}
          </v-card-text>
        </div>
        <div v-else>
          <v-card-text class="py-1">
            <div v-if="!messageError">
              <div class="text-body-2">
                {{ $t("generic.On") }} {{ this.substancesToSearch }}
                {{ $t("generic.line") }}(s) :
                {{ substancesImportResult.length }}
                {{ $t("generic.substance") }}(s) {{ $t("generic.found(s)") }}
                <span v-if="type === 'fav'">
                  <span v-if="substancesImportResultError.double">
                    {{ $t("generic.whose") }}
                    {{ substancesImportResultError.double }}
                    {{ $t("import.alreadyInFav") }}
                  </span>
                </span>
              </div>
              <div
                class="text-body-2"
                v-if="substancesImportResultError.notFound.length"
              >
                {{ substancesImportResultError.notFound.length }}
                {{ $t("generic.line") }}(s) {{ $t("import.withoutResult") }}
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <a v-bind="attrs" v-on="on">
                      ({{ $t("import.Error.list") }})
                    </a>
                  </template>
                  <span>{{ substancesImportResultError.notFound }}</span>
                </v-tooltip>
              </div>
            </div>
            <div v-else>
              <div class="">{{ messageError }}</div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="closeAnalyse">
              {{ $t("generic.cancel") }}
            </v-btn>
            <div v-if="type === 'fav'">
              <!-- i mode fav, affiche un bouton de mise en fav -->
              <v-btn
                color="primary"
                @click="addToFav"
                :disabled="!isSubToImport"
              >
                {{ $t("generic.import") }}
                <span v-if="subToAdd.length">
                  {{ subToAdd.length }} {{ $t("generic.substance") }}(s)
                </span>
              </v-btn>
            </div>
            <div v-else>
              <!-- Si mode search affiche un bouton de recherche -->
              <v-btn
                color="primary"
                @click="searchSub(subToAdd)"
                :disabled="!isSubToImport"
              >
                {{ $t("generic.Search") }}
                <span v-if="subToAdd.length">
                  {{ subToAdd.length }} {{ $t("generic.substance") }}(s)
                </span>
              </v-btn>
            </div>
            <v-spacer></v-spacer>
          </v-card-actions>
        </div>
      </v-card>
    </v-expand-transition>
  </v-card>
</template>

<script>
import readXlsxFile from "read-excel-file";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { monitore } from "./helpers/helpers";

export default {
  data: () => ({
    substancesImportExcel: [], // all sub on the excel
    substancesImportExcelFamilies: [], // all family sub on the excel
    substancesImportExcelError: { empty: [], format: [], double: [] }, // all sub unreadable from the excel
    displayAnalyseBack: false, // expansion when back end analyse and show result
    loaderBackEnd: false, // analyse data on back end
    isSubToImport: false,
    isSubToSearch: false,
    substancesImportResult: [], // all sub find by Backend
    substancesImportResultError: { double: 0, notFound: [] }, // all line not find by backend
    subToAdd: [], // sub to import
    messageError: "",
    erreurExcel: "",
    substancesEx: [
      { usual_name: "Exemple", ce: "123-456-7", cas: "12345-67-8" },
    ],
    columns: [
      {
        label: "Name",
        field: "usual_name",
      },
      {
        label: "N°CE",
        field: "ce",
      },
      {
        label: "N°CAS",
        field: "cas",
      },
    ],
  }),
  props: {
    type: {
      type: String,
      validator: (val) => ["fav", "search"].includes(val),
    },
    substancesImportedToSearch: Array,
  },
  computed: {
    ...mapGetters(["subs_fav"]),
    substancesToSearch() {
      return (
        this.substancesImportExcel.length +
        this.substancesImportExcelFamilies.length
      );
    },
  },
  model: {
    prop: "substancesImportedToSearch",
    event: "searchSub",
  },
  methods: {
    ...mapMutations(["setFavoritesSubstances", "addSubFav"]),
    ...mapActions(["updateProfile"]),
    closeImport() {
      this.displayAnalyseBack = false;
      this.loaderBackEnd = false;
      this.$emit("closeImport");
    },
    closeAnalyse() {
      this.displayAnalyseBack = false;
      this.loaderBackEnd = false;
      this.isSubToSearch = true;
    },
    // Read the file and import each line on substanceImport
    onFileChange(file) {
      this.erreurExcel = "";
      this.substancesImportExcel = [];
      this.substancesImportExcelFamilies = [];
      this.substancesImportExcelError = { empty: [], format: [], double: [] };
      this.isSubToSearch = false;
      let xlsxfile = file;
      readXlsxFile(xlsxfile).then((rows) => {
        if (rows.length) {
          let tmpSubstancesImport = rows.slice(1, rows.length);

          // Check le format de l'entete du tableau
          let casCount = 0;
          let ceCount = 0;
          let nameCount = 0;
          let enteteCount = 0;
          rows[0].forEach((el) => {
            enteteCount += 1;
            if (el === "N°CAS") {
              casCount += 1;
            }
            if (el === "N°CE") {
              ceCount += 1;
            }
            if (el === "Name") {
              nameCount += 1;
            }
          });

          // Analyse si entete OK
          if (
            ceCount !== 1 ||
            casCount !== 1 ||
            nameCount !== 1 ||
            enteteCount !== 3
          ) {
            console.log(
              "Fichier non lisible trop de colonne ce et/ou cas et/ou name"
            );
            this.erreurExcel = this.$t("import.Error.header");
          } else {
            let tmpCONCAT = []; // for check double
            tmpSubstancesImport.forEach((row, i) => {
              if (i > 999) {
                this.erreurExcel = this.$t("import.Error.tooManyLines");
              } else {
                let substance = { line: i + 2 };
                let family = { line: i + 2 };
                // index -> column
                let rowError = false;
                let casEmpty = false;
                let ceEmpty = false;
                let name = "";
                const regexCE = /^[0-9]{3}-[0-9]{3}-[0-9]{1}$/;
                const regexCAS = /^[0-9]{2,6}-[0-9]{2}-[0-9]{1}$/;
                row.forEach((value, index) => {
                  if (rows[0][index] === "N°CAS" || rows[0][index] === "N°CE") {
                    if (rows[0][index] === "N°CE") {
                      // console.log("CE REGEX :", regexCE.test(value));
                      if (!regexCE.test(value)) {
                        if (!value) {
                          ceEmpty = true;
                        } else {
                          rowError = true;
                        }
                      }
                    }
                    if (rows[0][index] === "N°CAS") {
                      // console.log("CAS REGEX :", regexCAS.test(value));
                      if (!regexCAS.test(value)) {
                        if (!value) {
                          casEmpty = true;
                        } else {
                          rowError = true;
                        }
                      }
                    }
                    // console.log(rowError);
                    let key = "";
                    if (rows[0][index] === "N°CAS") {
                      key = "cas";
                    }
                    if (rows[0][index] === "N°CE") {
                      key = "ce";
                    }
                    substance[`${key}`] = value;
                  }
                  if (rows[0][index] === "Name") {
                    name = value;
                  }
                });
                let concat = `${substance.ce}:${substance.cas}`;
                if (rowError) {
                  if (tmpCONCAT.indexOf(concat) < 0) {
                    tmpCONCAT.push(concat);
                    this.substancesImportExcelError.format.push(i + 2);
                  } else {
                    this.substancesImportExcelError.double.push(i + 2);
                  }
                } else if (casEmpty && ceEmpty) {
                  if (name) {
                    family["name"] = name;
                    this.substancesImportExcelFamilies.push(family);
                  } else {
                    this.substancesImportExcelError.empty.push(i + 2);
                  }
                } else {
                  if (tmpCONCAT.indexOf(concat) < 0) {
                    tmpCONCAT.push(concat);
                    this.substancesImportExcel.push(substance);
                    this.isSubToSearch = true;
                  } else {
                    this.substancesImportExcelError.double.push(i + 2);
                  }
                }
              }
            });
          }
        }
      });
      // console.log("EXPORT DES DATA EXCEL - ", this.substancesImportExcel);
      // console.log("ERREUR EXPORT - ", this.substancesImportExcelError);
    },
    // Function to search substance in the DB
    async send() {
      try {
        this.displayAnalyseBack = true;
        this.loaderBackEnd = true;
        this.isSubToSearch = false;
        this.subToAdd = [];

        let url = "/importlistsub";
        const response = await this.axios({
          method: "post",
          url: url,
          data: {
            substances: this.substancesImportExcel,
            families: this.substancesImportExcelFamilies,
          },
        });
        // console.log(response);
        if (response.status === 200) {
          if (response.data.substances.length) {
            this.substancesImportResult = response.data.substances;
            this.substancesImportResultError.notFound = response.data.errors;
            // count favoris
            this.substancesImportResultError.double = 0;
            this.substancesImportResult.forEach((sub) => {
              if (this.type === "fav") {
                if (this.subs_fav.indexOf(sub._id) >= 0) {
                  this.substancesImportResultError.double += 1;
                } else {
                  this.subToAdd.push(sub);
                  this.isSubToImport = true;
                }
              } else {
                this.subToAdd.push(sub);
                this.isSubToImport = true;
              }
            });
            this.loaderBackEnd = false;
          } else {
            console.log(response.data);
            this.loaderBackEnd = false;
            this.messageError = this.$t("import.Error.noResult");
          }
        } else {
          setTimeout(() => {
            console.log(response.data);
            this.loaderBackEnd = false;
            this.messageError = this.$t("import.Error.serverError");
          }, 2000);
        }
      } catch (err) {
        console.error(err);
        setTimeout(() => {
          this.loaderBackEnd = false;
          this.messageError = this.$t("import.Error.serverError");
        }, 2000);
      }
    },
    addToFav() {
      this.isSubToImport = false;
      this.displayAnalyseBack = false;
      let array_of_sub = [];
      this.subToAdd.forEach((sub) => {
        this.addSubFav(sub._id);
        array_of_sub.push(sub._id);
      });
      monitore("Import substances fav", { data: array_of_sub.length });
      this.updateProfile();
      this.$emit("updateFav");
      this.$nextTick(() => {});
    },
    searchSub(substances) {
      this.isSubToImport = false;
      this.displayAnalyseBack = false;
      let subIDS = substances.map((sub) => {
        return sub._id;
      });
      monitore("Import substances search", { data: substances.length });
      this.$emit("searchSub", subIDS);
    },
  },
};
</script>